import { useEffect, useState } from 'react'; // State kullanmak için gerekli
import { Container, Row, Col, Card } from 'react-bootstrap';
import '../Global.css';
import axios from 'axios';
import Navbar from '../components/Navbar';
import { useSearchParams } from 'react-router-dom';
import api from '../api';
function Play() {
    // 1. Başlangıç verileri
    const [competitors, setCompetitors] = useState([]);
    const [winnersOfRound, setWinnersOfRound] = useState([]); // Bu turda kazananlar burada birikir
    const [currentIndex, setCurrentIndex] = useState(0); // Şu an kapışan çiftin ilk elemanının indeksi
    const [champion, setChampion] = useState(null);
    const [tourControl, setTourControl] = useState(1);
    const [status, setStatus] = useState(0);
    const [url, setUrl] = useState(null);
    const [choice, setChoice] = useState("");
    const [searchParams] = useSearchParams();
    const [forTop, setForTop] = useState();
    const [playlistData, setPlaylistData] = useState(null);
    const [byeCompetitors, setByeCompetitors] = useState();
    const [currentMatches, setCurrentMatches] = useState();
    const [topWinners, setTopWinners] = useState([]);
    // 'q' parametresini alıyoruz
    const singerId = searchParams.get('q');
    const tournamentId = searchParams.get("id");
    const type = searchParams.get("type");

    const searchPlaylist = async () => {
        try {
            let token = localStorage.getItem("JWTTOKEN");
            let searchUrl, response;
            console.log(`type: ${type}, tournamentId: ${tournamentId}`);
            if (type === "top-artist" && tournamentId) {
                response = await api.get("/v1/tournament/id/" + tournamentId).then(async (res) => {
                    console.log("gelen data:", res.data);
                    if (res.data.data === null) {
                        const topresponse = await api.post("/v1/music/topArtist/", { id: tournamentId }, { headers: { Authorization: `Bearer ${token}` } }).then((top) => {

                            console.log("top");
                            console.log("topdatadata:", top.data.data);
                            setPlaylistData(top.data.data);
                            console.log("playlistdata:", playlistData);
                        }).catch((err) => console.error("hata:", err));

                    } else {
                        setPlaylistData(res.data.data);
                    }
                    setStatus(1);

                }).catch((err) => console.log(err));
            } else {
                response = await api.post("/v1/music/search/", { playlistId: url }, { headers: { Authorization: `Bearer ${token}` } }).then((res) => {
                    console.log("playlistten dönen:", res.data.data);
                    setStatus(1);
                    setPlaylistData(res.data.data);

                }).catch((err) => console.log(err));

            }


        } catch (err) {
            console.log(err);
        }
    }

    const createTournament = async (id) => {
        try {
            console.log("turnuva olusturuluyor");
            let choiceUrl;
            if (choice === "top") {
                choiceUrl = `https://api.turnaments.com/v1/music/topArtist/`
            }/*  else if (choice === "turnuva") {
                choiceUrl = `https://api.turnaments.com/v1/tournament/id/${tournamentId}`;
            }  */
            let response;
            let data = [];
            /*    if (choiceUrl) {
                   let token = localStorage.getItem("JWTTOKEN");
                   console.log("giden id:", id);
                   response = await axios.post(choiceUrl, { id }, { headers: { Authorization: `Bearer ${token}` } }).then((res) => {
                       data = res.data.data.decisions;
                       console.log("top");
                       console.log("data:", data);
                   }).catch((err) => console.error("hata:", err));
   
               } else {
                   console.log("top değil yine");
               }
    */


            if (choice === "sarki") {
                console.log("sarki:", playlistData.decisions);
                data = playlistData.decisions;
            }

            if (choice === "sanatci") {
                console.log("sanatcıya girdi...");
                console.log("id:", playlistData.id);
                let token = localStorage.getItem("JWTTOKEN");
                await api.post("/v1/music/artist",
                    { _id: playlistData.id },
                    { headers: { Authorization: `Bearer ${token}` } }
                ).then((response) => {
                    data = response.data.artistList;
                    console.log("data:", data);
                }).catch((err) => {
                    console.log(err);
                })
            }

            if (playlistData && tournamentId) {
                data = playlistData.decisions
            }

            let n = data.length;

            // Veriyi karıştır
            const shuffledData = data.sort(() => Math.random() - 0.5);

            // Bir sonraki 2'nin kuvvetini bul
            const nextPowerOfTwo = 2 ** Math.ceil(Math.log2(n));
            const numberOfByes = nextPowerOfTwo - n;

            console.log(`Toplam ${n} yarışmacı`);
            console.log(`İlk turda ${numberOfByes} kişi bay geçecek`);
            console.log(`Bracket boyutu: ${nextPowerOfTwo}`);

            // Bay geçenler ve maç yapacaklar
            const byeList = shuffledData.slice(0, numberOfByes);
            const matchingList = shuffledData.slice(numberOfByes);

            // İlk turu başlat
            setCompetitors(matchingList); // Sadece maç yapacakları göster
            setWinnersOfRound(byeList); // Bay geçenler zaten kazanan listesinde
            setStatus(2);

            console.log("Bay geçenler:", byeList.length);
            console.log("Maç yapacaklar:", matchingList.length);

        } catch (err) {
            console.log(err);
        }
    };

    // 2. Tıklama fonksiyonu (Sol veya Sağ seçildiğinde ortak çalışır)
    const handleSelect = (winnerName) => {
        const newWinners = [...winnersOfRound, winnerName];

        console.log("Kazanan:", winnerName);
        console.log("Mevcut index:", currentIndex);
        console.log("Toplam yarışmacı:", competitors.length);
        console.log("Toplam kazanan:", newWinners.length);

        // Eğer bu turda daha kapışacak kimse kalmadıysa (Tur Bitti)
        if (currentIndex + 2 >= competitors.length) {
            if (newWinners.length === 1) {
                setChampion(newWinners[0]);
            } else {
                // Yeni tura geç
                setCompetitors(newWinners);
                setWinnersOfRound([]);
                setCurrentIndex(0);
                setTourControl(1); // Yeni tur başladı
            }
        } else {
            // Tur devam ediyor: Sonraki iki kişiye geç
            setWinnersOfRound(newWinners);
            setCurrentIndex(currentIndex + 2);
            setTourControl(tourControl + 1);
        }
    };

    // Şu an yarışan iki kişi
    const leftSide = competitors[currentIndex];
    const rightSide = competitors[currentIndex + 1];

    useEffect(() => {
        console.log("singerid var:", singerId);
        if (singerId) {

            setChoice("top");
            createTournament(singerId);
        }

        if (tournamentId) {
            console.log("turnuva id var!");
            searchPlaylist()
        }

    }, [singerId])

    const endTournament = async () => {
        let token = localStorage.getItem("JWTTOKEN");
        console.log(`_id: ${playlistData.id}, title: ${champion.title}`);
        await api.post("/v1/tournament/endTournament", { _id: playlistData._id, winner: champion.title }, { headers: { Authorization: `Bearer ${token}` } }).then((res) => {
            console.log("endTournament:", res.data);

            setTopWinners(res.data.data);

        }).catch((err) => {
            console.log(err);
        })

    }

    useEffect(() => {
        if (champion !== null) {
            endTournament()
        }
    }, [champion])

    return (
        <div className='app-container'>
            <Navbar />
            <div className='main-content'>

                {status === 0 ? <div>
                    <input placeholder='link giriniz' className='form-check' value={url} onChange={(e) => setUrl(e.target.value)} />
                    <br />

                    <p onClick={searchPlaylist} style={{ padding: 10, backgroundColor: "#068c25", color: "white" }} className='pointer'>playlist ara</p>
                </div>
                    : status === 1 ? <div>

                        {playlistData && playlistData !== null ?
                            <div>
                                <img src={playlistData.image} width={200} height={200} />
                                <h2 style={{ color: "white" }}>{playlistData.title}</h2><br />
                                <b style={{ color: "white" }}>{playlistData.subtitle}</b>

                                <br />
                                <br />
                                <br />
                                <b style={{ color: "white" }}>toplam şarkı sayısı: {playlistData.decisions.length}</b>
                                {playlistData.decisions.map((track, index) => {
                                    return (
                                        <div
                                            key={track.title || index} // Unique key şart!
                                            style={{
                                                display: "flex", // Bu olmadan flexDirection çalışmaz
                                                flexDirection: "row",
                                                justifyContent: "space-between",
                                                alignItems: "center", // İçerikleri dikeyde ortalar
                                                marginBottom: "10px", // Şarkılar arasına boşluk
                                                gap: "15px" // Resim ile yazı arasına boşluk
                                            }}
                                        >
                                            <img
                                                src={track.image}
                                                alt={track.title}
                                                style={{ width: "50px", height: "50px", borderRadius: "4px" }}
                                            />

                                            <div style={{ flex: 1 }}> {/* Yazıların kalan alanı kaplaması için */}
                                                <p style={{ color: "white", margin: 0 }}>{track.title}</p>
                                                <b style={{ color: "gray", fontSize: "0.9rem" }}>{track.subtitle}</b>
                                            </div>
                                        </div>
                                    );
                                })}

                                {choice === "" ?
                                    <div>
                                        <p style={{ color: "white" }} onClick={() => setChoice("sarki")} > en iyi şarkı</p>
                                        <p style={{ color: "white" }} onClick={() => setChoice("sanatci")}>en iyi sanatçı</p>
                                    </div> : choice === "sarki" ?
                                        <div>
                                            <p style={{ color: "red" }} onClick={() => setChoice("sarki")}> en iyi şarkı</p>
                                            <p style={{ color: "white" }} onClick={() => setChoice("sanatci")}>en iyi sanatçı</p>
                                        </div> : <div>
                                            <p style={{ color: "white" }} onClick={() => setChoice("sarki")} > en iyi şarkı</p>
                                            <p style={{ color: "red" }} onClick={() => setChoice("sanatci")}>en iyi sanatçı</p>
                                        </div>}

                                <p onClick={createTournament} style={{ padding: 10, backgroundColor: "#068c25", color: "white" }} className='pointer'>turnuva oluştur</p>


                            </div>
                            : <b style={{ color: "white" }}>yükleniyor...</b>}


                    </div> : <div>
                        <h2 className='mt-4 text-center' style={{ color: "white" }}>En İyi Şarkıcı?</h2>
                        <p className='text-center ' style={{ color: "white" }}>Kalan Yarışmacı Sayısı: {competitors.length}</p>
                        <p className='text-center ' style={{ color: "white" }}>tur: ({tourControl}/{competitors.length / 2})</p>


                        {champion === null ? <Row className="mt-5 justify-content-center">
                            {/* Sol Seçenek */}
                            <Col xs={5}>
                                <Card
                                    style={{ backgroundColor: "#393939" }}
                                    className="text-center p-3 pointer"
                                    onClick={() => handleSelect(leftSide)}
                                >
                                    <Card.Body>
                                        <img src={leftSide.image} alt={leftSide.name || leftSide.title} />
                                        {choice === "sanatci" ?
                                            <h3 style={{ color: "white" }}>{leftSide.name}</h3> :
                                            <div>
                                                <h3 style={{ color: "white" }}>{leftSide.title}</h3>
                                                <br />
                                                <b style={{ color: "white" }}>{leftSide.subtitle}</b>
                                            </div>
                                        }
                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col xs={2} className="text-center d-flex align-items-center justify-content-center">
                                <h2 className="fw-bold" style={{ color: "white" }}>VS</h2>
                            </Col>

                            {/* Sağ Seçenek */}
                            <Col xs={5}>
                                <Card
                                    style={{ backgroundColor: "#393939" }}
                                    className="text-center p-3 pointer"
                                    onClick={() => handleSelect(rightSide)}
                                >
                                    <Card.Body>
                                        <img src={rightSide.image} alt={rightSide.name || rightSide.title} />
                                        {choice === "sanatci" ?
                                            <h3 style={{ color: "white" }}>{rightSide.name}</h3> :
                                            <div>
                                                <h3 style={{ color: "white" }}>{rightSide.title}</h3>
                                                <br />
                                                <b style={{ color: "white" }}>{rightSide.subtitle}</b>
                                            </div>
                                        }
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row> : <div>
                            <h2 style={{ color: "white" }}>şampiyon : {champion.title}</h2>
                            <img src={champion.image} />
                            <br />

                            {topWinners && topWinners.length > 0 ? topWinners.map((i) => {
                                return <div><b style={{ color: "white" }} >{i.title}</b><p style={{ color: "white" }} >{i.winAmount}</p><img src={i.image} style={{ width: 50, height: 50 }} /></div>
                            }) : <p>top winners yükleniyor</p>}
                        </div>}
                    </div>}
            </div>

        </div>

    );
}

export default Play;